import {
  RESPONSE_RANK_ERROR,
  RESPONSE_ERROR,
  RESPONSE_STATUS_ERROR,
} from "constants/messages/error";

// eslint-disable-next-line import/prefer-default-export
export const errorMessage = {
  rank: RESPONSE_RANK_ERROR,
  response: RESPONSE_ERROR,
  status: RESPONSE_STATUS_ERROR,
};
